import React from 'react';
import {
    SecurityListHeaderColumn,
    SecurityListColumn,
} from '../../../common';
import { BidLevel as BidLevelComponent } from '../../../seller/biddingSecurities';
import { BidLevel } from '../../../../../types/bidding/BidLevel';

export const fourth = {
    columnName: 'fourth',
    renderHeader: function () {
        return (
            <SecurityListHeaderColumn key={this.columnName} className="data-list-cell-xl-xxl cell-bid-on-top">
                Fourth
            </SecurityListHeaderColumn>
        );
    },
    renderBody: function (position, context) {
        return (
            <SecurityListColumn key={this.columnName} className="data-list-cell-xl-xxl cell-bid-on-top overflow-visible">
                <BidLevelComponent
                    level={BidLevel.Fourth}
                    positionId={position.id}
                    bids={position.bids}
                    stage2Participants={context.stage2Participants}
                    trade={position.trade}
                    allowFeedback={context.allowFeedback}
                    bwicStatus={context.bwicStatus}
                    process={context.bwic?.process}
                />
            </SecurityListColumn>
        );
    }
};
